import jwtDecode from "jwt-decode";

export const TOKEN_KEY = "@Lit/token";
export const isAuthenticated = () => localStorage.getItem(TOKEN_KEY) !== null;
export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const login = token => {
  const decodeToken = jwtDecode(token);
  localStorage.setItem(TOKEN_KEY, token);
  if (decodeToken.company) {
    localStorage.setItem("company", decodeToken.company);
  }

  if(decodeToken.tenant) {
    const tokenTenant = localStorage.getItem("tokenTenant");
    if(!tokenTenant) {
      localStorage.setItem("tokenTenant", decodeToken.tenant);
    }
    // Só semeia `tenant` a partir do claim do JWT no primeiro login.
    // NÃO sobrescreve um tenant já selecionado: login() é chamado a cada
    // refresh de token (response interceptor em api.js) e o claim "principal"
    // do JWT pode divergir do tenant em que o usuário está operando
    // (ex.: LIT_BUSINESS vs SAINTPAUL). A troca de tenant (ModalTenancy)
    // seta `tenant` explicitamente.
    if(!localStorage.getItem("tenant")) {
      localStorage.setItem("tenant", decodeToken.tenant);
    }
  }

  if(decodeToken.crCode) {
    const tokenCrCode = localStorage.getItem("tokenCrCode"); 
    if(!tokenCrCode){
      localStorage.setItem("tokenCrCode", decodeToken.crCode);
    }
    localStorage.setItem("crCodeProfile", decodeToken.crCode);
  }
};

// Aplica um token reemitido para um novo perfil (ex.: renovação após a compra
// de um plano). Diferente de login(), sobrescreve o tenant e o perfil já
// salvos: o tenant/perfil do token anterior (ex.: LIT_BUSINESS do cadastro)
// deixou de valer e, se mantido, é enviado no header Tenant e tem prioridade
// sobre o token no gateway. Também descarta home/turma do perfil anterior.
export const applyRenewedToken = token => {
  if (!token) return;

  login(token);

  const decodeToken = jwtDecode(token);
  if (decodeToken.tenant) {
    localStorage.setItem("tenant", decodeToken.tenant);
    localStorage.setItem("tokenTenant", decodeToken.tenant);
  }
  if (decodeToken.crCode) {
    localStorage.setItem("tokenCrCode", decodeToken.crCode);
    localStorage.setItem("crCodeProfile", decodeToken.crCode);
  }

  localStorage.removeItem("homeCrCode");
  localStorage.removeItem("defaultHomeCrCode");
  localStorage.removeItem("selectedClassName");
  localStorage.removeItem("selectedClassCrCode");
};
export const logout = () => {
  localStorage.clear();
};
export const urlencode = (str) => {
  str = (`${str  }`).toString();

  // Tilde should be allowed unescaped in future versions of PHP (as reflected below), but if you want to reflect current
  // PHP behavior, you would need to add ".replace(/~/g, '%7E');" to the following.
  return encodeURIComponent(str)
    .replace('!', '%21')
    .replace('\'', '%27')
    .replace('(', '%28')
    .replace(')', '%29')
    .replace('*', '%2A')
    .replace('%20', '+');
}